export default "/images/help-hook-and-title.png?0ebe7318ab0ce80bc0ce05d95048a187";